import React, { useEffect, useRef } from "react";
import BouncingDiv from "../BouncingDiv";
import Molly from "../assets/videos/molly.mp4";
import MollyPills from "../assets/images/molly-pills.gif";
import YMLogo from "../assets/YMLogo";
import { useNavigate } from "react-router-dom";

export default function MollyPage() {
  const canvasRef = useRef();
  const videoRef = useRef();
  const navigate = useNavigate();

  return (
    <div
      id="bounce-container"
      className="relative flex h-[100dvh] min-w-[100dvw] flex-1 shrink-0  snap-center items-center justify-center bg-amber-100"
    >
      <canvas ref={canvasRef} className=" hidden w-full" />
      <video
        autoPlay
        id="video-background"
        ref={videoRef}
        muted
        loop
        playsInline
        className="absolute flex h-full w-full object-cover "
        onLoad={() => {
          console.log("loaded");
        }}
      >
        <source src={Molly} type="video/mp4" />
      </video>
      <div className="font-rubikDirt absolute left-0 top-0 min-h-[100dvh] w-[100dvw] text-[yellow] mix-blend-difference">
        <p
          className="relative flex items-center justify-center mix-blend-difference"
          style={{
            writingMode: "vertical-lr",
            textOrientation: "upright",
            textShadow: "4px 5px 25px yellow",
            fontSize: "17vh",
            letterSpacing: "-40px",
            maxWidth: "max(120px,40vw)",
            height: "100%",
            overflow: "hidden",
            paddingTop: "20px",
            // background: "red",
            cursor: "pointer",
          }}
        >
          <img
            src={MollyPills}
            alt=""
            className="absolute left-0 top-0 h-full max-w-[100%] object-cover opacity-[0.4] mix-blend-difference"
            style={{
              filter: "hue-rotate(40deg)",
            }}
          />
          <p
            className="relative left-0  cursor-pointer bg-[transparent]"
            onClick={() => {
              navigate("videos?videoId=Molly");
            }}
            // href="https://www.youtube.com/watch?v=FhDuvafS1og"
          >
            MOLLY
          </p>
        </p>
        <p className="absolute right-0 top-[10vh] text-[max(45px,3vw)] tracking-wider max-sm:text-[5vw]">
          FOOT X AZMUTH
        </p>
      </div>
      <BouncingDiv size={50}>
        <YMLogo />
      </BouncingDiv>
    </div>
  );
}
